import { __rest, __assign } from 'tslib';
import React, { useState } from 'react';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FaIcon } from '@panwds/react-ui';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';
import { Pill } from '../Pill/Pill.esm.js';
import '../Pill/PillValue.esm.js';
import { TextInput } from './TextInput.esm.js';

var TextInputFilter = function (_a) {
    var errorMessage = _a.errorMessage, name = _a.name, label = _a.label, onClose = _a.onClose, onValidate = _a.onValidate, rest = __rest(_a, ["errorMessage", "name", "label", "onClose", "onValidate"]);
    var _b = useFilters(), filters = _b.filters, setFilters = _b.setFilters;
    var filterValue = filters[name];
    var _c = useState(), errorLabel = _c[0], setErrorLabel = _c[1];
    /** An optional function for input validation */
    var handleValueSubmit = function (value) {
        var _a, _b;
        if (onValidate) {
            onValidate(value)
                ? (setFilters((_a = {}, _a[name] = value, _a)), setErrorLabel(""))
                : setErrorLabel(errorMessage);
        }
        else {
            setFilters((_b = {}, _b[name] = value, _b));
        }
    };
    return (React.createElement("div", null,
        React.createElement(Pill, { label: label, onClose: onClose, select: React.createElement(TextInput, __assign({}, rest, { onValueSubmit: handleValueSubmit, filterValue: filterValue })) }),
        onValidate && (React.createElement("span", { className: "tw-text-red tw-text-xs tw-font-lato tw-m-0 tw-pl-2" },
            React.createElement("span", null, errorLabel && React.createElement(FaIcon, { faIconDef: faExclamationCircle })),
            React.createElement("span", { className: "tw-ml-1 tw-relative tw-top-0.5" }, errorLabel)))));
};

export { TextInputFilter };
//# sourceMappingURL=TextInputFilter.esm.js.map
